import axios from "axios";
import {
  FETCH_INVENTORY_COLORS_REQUEST,
  FETCH_INVENTORY_COLORS_SUCCESS,
  FETCH_INVENTORY_COLORS_FAILURE
} from "Constants/redux";
import { ROOT_URL } from "Api";

export function fetchInventoryColors(query = "") {
  return (dispatch, getState) => {
    const { location } = getState().locations;
    dispatch({ type: FETCH_INVENTORY_COLORS_REQUEST });
    axios
      .get(
        `${ROOT_URL}/portal/inventories/colors?location_id=${location.id}&query=${query}`
      )
      .then(response => {
        return dispatch({
          response,
          type: FETCH_INVENTORY_COLORS_SUCCESS
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({
          error,
          type: FETCH_INVENTORY_COLORS_FAILURE
        });
      });
  };
}
